export const VIEW_EVENT_AFTER_INITIAL_RENDER = 'afterInitialRender';
export const VIEW_EVENT_AFTER_RENDER = 'afterRender';
export const VIEW_EVENT_BEFORE_INITIAL_RENDER = 'beforeInitialRender';
export const VIEW_EVENT_BEFORE_RENDER = 'beforeRender';
export const VIEW_EVENT_AFTER_VIEW_NAME_CHANGE = 'afterViewNameChange';
